import Button from "@mui/material/Button";

interface ButtonAppProps {
  label: string;
  primary: boolean;
  onclick: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export default function ButtonApp(props: ButtonAppProps) {
  const { label, primary, onclick, loading, disabled = false } = props;

  return (
    <Button
      size="large"
      variant={primary ? "contained" : "outlined"}
      onClick={onclick}
      loading={loading}
      loadingPosition="start"
      disabled={disabled}
    >
      {label}
    </Button>
  );
}
